import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const DeleteTicketLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-remove'
      text={t('ticketProviderTicketPage.deleteTicketLink')}
    />
  )
}

DeleteTicketLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default DeleteTicketLink
